import type { API, TRequestsHandler } from '~/utils/requestsProcessor/types';

export class StakeImpl {
  constructor(private readonly makeRequest: TRequestsHandler) {}

  /** GET /stake */
  public getStake(query: { address: string; limit?: number; offset?: number }) {
    return this.makeRequest<API.StakeListResponse>(`stake`, {
      method: 'GET',
      query
    });
  }

  /** GET /v1/stake */
  public getV1Stake(query: { sender: string; token: string; limit?: number; offset?: number; sort?: 'asc' | 'desc' }) {
    return this.makeRequest<API.StakeListResponseV1>(`v1/stake`, {
      method: 'GET',
      query
    });
  }
}
